import { render, staticRenderFns } from "./FriendshipManagementList.vue?vue&type=template&id=1a9e55e4"
import script from "./FriendshipManagementList.vue?vue&type=script&lang=js"
export * from "./FriendshipManagementList.vue?vue&type=script&lang=js"
import style0 from "./FriendshipManagementList.vue?vue&type=style&index=0&id=1a9e55e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports